import { Component } from '@angular/core';

@Component({
  selector: 'app-content-card9',
  imports: [],
  templateUrl: './content-card9.component.html',
  styleUrl: './content-card9.component.scss'
})
export class ContentCard9Component {

}
